export default __webpack_public_path__ + "static/media/custom_colors_s.4cfa1a71.jpg";